var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as ngCommon from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap';
import { ConfigureRouteGuard } from './auth/auth-route-guard';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { AbpModule } from 'abp-ng2-module/src/abp.module';
var ConfigureCommonModule = /** @class */ (function () {
    function ConfigureCommonModule() {
    }
    ConfigureCommonModule_1 = ConfigureCommonModule;
    ConfigureCommonModule.forRoot = function () {
        return {
            ngModule: ConfigureCommonModule_1,
            providers: [
                ConfigureRouteGuard
            ]
        };
    };
    var ConfigureCommonModule_1;
    ConfigureCommonModule = ConfigureCommonModule_1 = __decorate([
        NgModule({
            imports: [
                ngCommon.CommonModule,
                FormsModule,
                ModalModule.forRoot(),
                // UtilsModule,
                AbpModule,
                CommonModule,
                TableModule
            ],
            declarations: [],
            exports: []
        })
    ], ConfigureCommonModule);
    return ConfigureCommonModule;
}());
export { ConfigureCommonModule };
